import { useQuery } from 'react-query';

import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';
import { expensesApi } from 'src/Services/API';

const useFetchDeductibleCharges = (year: number) => {
  const assetId = useCurrentAssetId();
  return useQuery({
    queryKey: ['fetch-deductible-charges', assetId, year],
    queryFn: async () => {
      if (!assetId) throw new Error('No assetId provided');

      return (await expensesApi.expensesControllerFindDeductibleCharges(assetId, year)).data;
    },
    enabled: !!assetId,
    staleTime: 5 * 60 * 1000,
  });
};

export default useFetchDeductibleCharges;
